export default {"src":"/_next/static/media/openai.01c69e79.svg","height":2577,"width":2577,"blurWidth":0,"blurHeight":0};